module.exports = __webpack_public_path__ + "static/media/earth-loop.f2e08100.mov";